"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.DayInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _input = _interopRequireDefault(require("@kyruus/input"));
const DayInput = exports.DayInput = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    config,
    errors,
    onBlur,
    onChange,
    required,
    value
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_input.default, {
    ariaDescription: config.ariaDescription,
    autoComplete: config.autoComplete,
    className: "day-input",
    "data-testid": config.name,
    errors: errors,
    hideErrors: true,
    hideLabel: true,
    id: config.name,
    inputMode: "numeric",
    label: config.label,
    maxLength: "2",
    name: config.name,
    onBlur: onBlur,
    onChange: onChange,
    placeholder: config.placeholder,
    ref: ref,
    required: required,
    value: value
  });
});
DayInput.displayName = 'DayInput';
DayInput.propTypes = {
  /**
   * The config object that drives the construction of the input
   */
  config: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    initialValue: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    autoComplete: _propTypes.default.string,
    ariaDescription: _propTypes.default.string.isRequired,
    invalidMsg: _propTypes.default.string.isRequired,
    isRequiredMsg: _propTypes.default.string.isRequired
  }).isRequired,
  /**
   * The errors to render under the input
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * The function to call onBlur
   */
  onBlur: _propTypes.default.func.isRequired,
  /**
   * The function to call onChange
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * Whether or not this input is required
   */
  required: _propTypes.default.bool,
  /**
   * The current value of the input, driven by state
   */
  value: _propTypes.default.string.isRequired
};
DayInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DayInput",
  "props": {
    "config": {
      "description": "The config object that drives the construction of the input",
      "type": {
        "name": "shape",
        "value": {
          "label": {
            "name": "string",
            "required": true
          },
          "name": {
            "name": "string",
            "required": true
          },
          "initialValue": {
            "name": "string",
            "required": false
          },
          "placeholder": {
            "name": "string",
            "required": false
          },
          "autoComplete": {
            "name": "string",
            "required": false
          },
          "ariaDescription": {
            "name": "string",
            "required": true
          },
          "invalidMsg": {
            "name": "string",
            "required": true
          },
          "isRequiredMsg": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": true
    },
    "errors": {
      "description": "The errors to render under the input",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "onBlur": {
      "description": "The function to call onBlur",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onChange": {
      "description": "The function to call onChange",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "required": {
      "description": "Whether or not this input is required",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "value": {
      "description": "The current value of the input, driven by state",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};